import { Icon } from "@mui/material";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import tipsService from "../../services/TipsService";
import canaisService from "../../services/CanaisService";
import { Search } from "@mui/icons-material";
import Select from "react-select";
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import SectionCategoryDetails from "components/sectionCategoryDetails/sectionCategoryDetails";
import FiltersPost from "components/posts/FiltersPost";
import { getTipsFilters } from "services/post/FilterService";
import Advertising from "components/ad/Advertising";
import Pagination from "components/table/Pagination";


export const selectStyles = {
  control: (base: any, state: any) => ({
    ...base,
    cursor: "pointer",
    borderRadius: "1.228rem",
    border: "1px solid #d8d6de",
    padding: "3px 10px",
    maxWidth: "250px",
    minWidth: "250px",
    "&:hover": {},
  }),
  menu: (provided: any) => ({
    ...provided,
    width: "auto", // Ajusta automaticamente a largura do menu de opções
    minWidth: "300px", // Define uma largura mínima para o menu de opções
  }),
};

//teste

export const selectThemeColors = (theme: any) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: "#cebab1", // for option hover bg-color
    primary: "#A27C6A", // for selected option bg-color
    neutral10: "#cebab1", // for tags bg-color
    neutral20: "#cebab1", // for input border-color
    neutral30: "#cebab1", // for input hover border-color
  },
});

const TipsWithAdvertisement: React.FC = () => {
  const { categoryId } = useParams();
  const [loading, setLoading] = useState(true);
  const [dicas, setDicas] = useState([]);

  const [descriptionCategory, setDescriptionCategory] = useState("");
  const [urlCategory, setUrlCategory] = useState("");

  const [categoriaSelected, setCategoriaSelected]: any = useState(categoryId);
  const [nameCategoriaSelected, setNameCategoriaSelected] = useState("");

  const [search, setSearch] = useState("");
  const [searchValue, setSearchValue] = useState("");

  const [banner, setBanner] = useState("");
  const [filtersTmp, setFiltersTmp] = useState(null);

  const [startLock, setStartLock] = useState(true);

  const [paginationData, setPaginationData] = useState<any>();
  const [filtersData, setFiltersData] = useState<any>();
  const [externalFilters, setExternalFilters] = useState<any>(null);

  const navigate = useNavigate();

  const getDicas = async (filters : any = null) => {

    setLoading(true);

    if (search) {
      filters = { ...filters, search: search };
    }

    await tipsService
      .getTips(filters)
      .then((response: any) => {

        setDicas(response.data);

        setPaginationData({
          current_page: response.current_page,
          last_page: response.last_page,
          per_page: response.per_page,
          total: response.total,
        });
      })
      .catch((error: any) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getCanais();
  }, []);

  // Limpar filtros externos após serem aplicados
  useEffect(() => {
    if (externalFilters) {
      const timer = setTimeout(() => {
        setExternalFilters(null);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [externalFilters]);

  const getCanais = async (categoryIdParam = null) => {
    setLoading(true); // start loading

    try {
      const response = await canaisService.getCanais(1, "");

      let dadosCategory: any = response.categories.find(
        (e: any) => e.id == (categoryIdParam ?? categoriaSelected)
      );
    
      setBanner(
        process.env.REACT_APP_BACKEND_API_URL +
          "/storage/images/categories/banners/" +
          dadosCategory?.banner_path
      );
      setDescriptionCategory(dadosCategory?.description);
      setUrlCategory(dadosCategory?.url_video);

      setNameCategoriaSelected(dadosCategory?.name);

      if (startLock) {
        setStartLock(false);

        if (categoryId) {
          getDicas({ category: { value: categoryId } });
        } else {
          getDicas();
        }
      };
    } catch (error) {
      // console.error(error);
    }
  };

  const handlePaginationChange = async (page: number) => {
    await getDicas({
      ...filtersData,
      page: page,
    });
  }

  // const selecionarSubcategoriaTag = (subcategoria: any) => {
  //   setSubCategoriaSelected(subcategoria);
  //   setLoadingSubCategories(true);
  //   setTimeout(() => {
  //     setLoadingSubCategories(false);
  //   }, 10);
  // };

  const listarDicas = () => {
    return dicas.map((dica: any) => {
      const urlBase: any =
        process.env.REACT_APP_BACKEND_API_URL + "/storage/users/";
      const ImageUrl: any = urlBase + `/${dica.post.user.avatar_path}`;
      return (
        <>
          <li className="flex items-center text-justify w-full bg-gray-100 border border-gray-200 px-4 dark:bg-gray-600 rounded-3xl height-auto">
            <div className="flex-grow my-5">
              <div className="flex md:flex-row">
                <span
                  onClick={() => handleCategoryClick(dica.category.id, dica.category.name)}
                  className="bg-primary-600 text-white text-xs font-medium me-2 px-5 py-0.5 rounded-full dark:bg-slate-700 text-center cursor-pointer hover:bg-primary-700 transition-colors"
                >
                  {dica.category.name}
                </span>
                <span
                  onClick={() => handleSubCategoryClick(dica.subcategory.id, dica.subcategory.name, dica.category.id)}
                  className="bg-primary-400 text-white text-xs font-medium me-2 px-5 py-0.5 rounded-full dark:bg-slate-700 text-center cursor-pointer hover:bg-primary-500 transition-colors"
                >
                  {dica.subcategory.name}
                </span>
              </div>
              <div
                onClick={() => {
                  navigate("/dicas-detalhes/" + dica.id);
                }}
                className="flex-row mt-6 cursor-pointer"
              >
                <span className="w-full font-semibold lg:text-2xl md:text-xl">
                  {dica.name}
                </span>
              </div>
              {/* <div className="mt-5">
                <div className="flex justify-between">
                  <div>
                    <span className="text-gray-400 mb-[-12px] font-14">
                      {dica.site} | {dica.phone} | {dica.email}
                    </span>
                  </div>
                </div>
              </div> */}
              <div>
                <div className="flex w-full mt-5">
                  <img
                    alt=""
                    className="rounded-full h-10 w-10 object-cover"
                    src={ImageUrl}
                  ></img>

                  <div className="ms-4">
                    <div className="flex justify-between">
                      <div>
                        <span className="text-gray-600 dark:text-white font-medium mb-[-18px]">
                          {dica.post.user.display_name}
                        </span>
                        <br />
                        <span className=" text-gray-400">
                          {format(
                            parseISO(dica.created_at),
                            "d 'de' MMMM, yyyy",
                            { locale: ptBR }
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <br />
        </>
      );
    });
  };

  const handleCategoryClick = (categoryId: number, categoryName: string) => {
    setExternalFilters({
      category: categoryId,
      subCategory: null
    });
  };

  const handleSubCategoryClick = (subCategoryId: number, subCategoryName: string, categoryId: number) => {
    setExternalFilters({
      category: categoryId,
      subCategory: subCategoryId
    });
  };

  const handleFilters = (filters: any) => {

    if (filters.category) {
      setCategoriaSelected(filters.category.value);
      getCanais(filters.category.value);
    }

    setFiltersTmp(filters);
    
    if (!startLock) {
      getDicas(filters);
    }
  }

  return (
    <div className="flex flex-col items-center mt-5 mx-3 md:mx-0">
      <div
        style={{ backgroundImage: `url(${banner})` }}
        className="flex mb-2 justify-center w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] h-96 bg-cover rounded-3xl bg-blend-darken bg-center"
      >
        <span className="flex bg-black bg-opacity-50 w-full justify-center font-semibold text-2xl md:text-5xl py-44 brightness-100 text-white rounded-3xl">
          {nameCategoriaSelected}
        </span>
      </div>
      <span className="w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem]">
        <Link to={"/"}>Home</Link> &gt; <Link to={"/dicas-geral"}>Dicas</Link>
      </span>
      {/* video-card */}
      <SectionCategoryDetails data={{ descriptionCategory, urlCategory }} />

      <div className="mb-2 sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem]">      
        <FiltersPost 
          categoryDefault={categoryId}
          filters={['category', 'subcategory', 'country', 'state', 'city', 'search']} 
          handleFilters={handleFilters} 
          getFilters={getTipsFilters} 
          filtersData={filtersData}
          setFiltersData={setFiltersData}
          externalFilters={externalFilters}
        />
      </div>

      <section>

        <div className="flex flex-col mb-10 px-4 md:px-0 lg:flex-row w-full gap-x-10 sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem]">

          <div className="w-100">

            <div className="flex-row justify-end">
              {/* <div className="flex items-center justify-start">
                <div className="flex gap-2 xl:gap-6">
                  <button className="flex items-center rounded-full h-12 dark:bg-gray-600 dark:text-white dark:hover:bg-gray-300 gap-x-2 px-4 md:px-8 mt-5 bg-white text-primary-700 hover:bg-primary-300 hover:text-white shadow-sm">
                    País
                    <Icon
                      component={KeyboardArrowDownOutlinedIcon}
                      fontSize="small"
                    />
                  </button>
                  <button className="flex items-center rounded-full h-12 dark:bg-gray-600 dark:text-white dark:hover:bg-gray-300 gap-x-2 px-4 md:px-8 mt-5 bg-white text-primary-700 hover:bg-primary-300 hover:text-white shadow-sm">
                    Estado
                    <Icon
                      component={KeyboardArrowDownOutlinedIcon}
                      fontSize="small"
                    />
                  </button>
                  <button className="flex items-center rounded-full h-12 dark:bg-gray-600 dark:text-white dark:hover:bg-gray-300 gap-x-2 px-4 md:px-8 mt-5 bg-white text-primary-700 hover:bg-primary-300 hover:text-white shadow-sm">
                    Cidade
                    <Icon
                      component={KeyboardArrowDownOutlinedIcon}
                      fontSize="small"
                    />
                  </button>
                </div>
              </div> */}

              <div className="flex flex-col lg:flex-row items-start lg:items-center justify-start lg:justify-between">

                <div className="flex gap-2 xl:gap-6 flex-wrap display-contet">

                  {/* <div className="w-100 m-1">
                    <Select
                      placeholder="Categoria"
                      value={listCategories.find(
                        (e: any) => e.value.id == categoriaSelected
                      )}
                      styles={selectStyles}
                      theme={selectThemeColors}
                      className={
                        "flex items-center rounded-full h-12  mt-5 text-primary-700 select-max-width"
                      }
                      onChange={(e: any) => selecionarCategoria(e.value)}
                      options={listCategories}
                      isClearable={false}
                    />
                  </div> */}

                  {/* <div className="w-100 m-1">
                    {!loadingSubCategories ? (
                      <Select
                        placeholder="Subcategoria"
                        value={listSubCategories.find(
                          (e: any) => e.value == subCategoriaSelected
                        )}
                        styles={selectStyles}
                        theme={selectThemeColors}
                        className={
                          "flex items-center rounded-full h-12  mt-5 text-primary-700 select-max-width"
                        }
                        onChange={(e: any) => setSubCategoriaSelected(e.value)}
                        options={listSubCategories}
                        isClearable={false}
                      />
                    ) : null}
                  </div>

                  <div className="flex items-end gap-x-2 px-4 mt-6 bg-white dark:bg-gray-400 rounded-full border border-gray-200 w-full h-full flex flex-row items-center">
                    <input
                      className="text-black bg-transparent border-transparent w-full overflow-hidden resize-none focus:rounded-l-full"
                      maxLength={42}
                      placeholder="Procurar por..."
                      onChange={(e) => setSearchValue(e.target.value)}
                    />
                    <div
                      onClick={() => setSearch(searchValue)}
                      className="flex justify-center items-center h-9 w-10 bg-primary-600 rounded-full shadow-md hover:bg-opacity-70 cursor-pointer"
                    >
                      <Icon
                        className="text-white"
                        component={Search}
                        fontSize="medium"
                      />
                    </div>
                  </div> */}
                </div>
              </div>
            </div>

            <div>
              <ul className="flex-grow w-full">
                <div className="mt-5">
                  {loading ? (
                    <div className="spinner border-primary-600"></div>
                  ) : dicas.length > 0 ? (
                    listarDicas()
                  ) : (
                    <div className="bg-primary-200 border shadow rounded-3xl w-100 p-8">
                      Nenhuma dica encontrada
                    </div>
                  )}
                </div>

                {
                  !loading && dicas.length > 0 && (
                    <div className="mt-5 flex justify-start">
                      <Pagination pagination={paginationData} fetchData={(page: number) => handlePaginationChange(page)} />
                    </div>
                  )
                }
              </ul>

              <div className="rounded-none mt-10 mb-5">
                <Advertising type="horizontal" categoryId={categoryId} />
              </div>
            </div>

            {/* <div>
              <div className="flex mb-10 justify-between">
                <div className="flex items-center justify-between w-full">
                  <button className="rounded-full w-full h-12 px-8 mt-5 bg-primary-800 dark:hover:bg-gray-300 text-white hover:bg-primary-500 shadow-sm">
                    Mostrar Mais
                  </button>
                </div>
              </div>
            </div> */}
          </div>

          <div className="w-full md:w-[300px] lg:w-[400px] mt-5 md:mt-0 pb-10 md:pb-0">
            <Advertising type="vertical" categoryId={categoryId} />
          </div>

        </div>
      </section>
    </div>
  );
};

export default TipsWithAdvertisement;
